var mediaGallery = {
  init: function(mediaWrap){
    const mediaGallery = $('.js-media-gallery-slide');
  
    mediaGallery.slick({
      infinite: true,
      arrows: false,
      dots: false
    });

    $('.js-media-gallery-arrow button').on('click', function(){
      var arrowType = $(this).attr('data-type');
      
      mediaGallery.slick(arrowType);
    })

    $('body').on('click', '.js-media-gallery-thumb', function(){
           const position = $(this).index();
      mediaGallery.slick('slickGoTo', position);
    })
  }
}
$(document).ready(function(){
  mediaGallery.init();
})